export default __webpack_public_path__ + "static/multiple-ways-illustration-light-05f29c0915f4b4e1e10d6584af215e75.svg";